


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { TYPE_EXCURSION_URL } from "../../settings/APISetting";
import { sortByProp } from "../../settings/themeSettings";
import api from "../../config/axiosConfig";

export const fetchTypeExcursion = createAsyncThunk('fetch-excursion', async (page = 1) => {
    const response = await api.get(TYPE_EXCURSION_URL);
    return response.data;
});


export const createTypeExcursion = (typeExcursion, err, cb) => {
    api.post(TYPE_EXCURSION_URL, typeExcursion)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const updateTypeExcursion = (typeExcursion, err, cb) => {
    api.put(`${TYPE_EXCURSION_URL}/${typeExcursion.id}`, typeExcursion)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const deleteTypeExcursion = (id, err, cb) => {
    api.delete(`${TYPE_EXCURSION_URL}/${id}`)
        .then((response) => {
            if (cb) cb(response);
        })
        .catch((error) => {
            if (err) err(error);
        });
}


const typeExcursionSlice = createSlice({

    name: 'typeExcursions',
    initialState: { typeExcursions: [], typeExcursionsFetchStatus: '' },

    reducers: {
        addTypeExcursion: (state, action) => {
            state.typeExcursions = [...state.typeExcursions, action.payload].sort((a, b) => sortByProp(a, b, 'libelle'));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTypeExcursion.fulfilled, (state, action) => {
            if (Array.isArray(action.payload)) {
                state.typeExcursions = [...action.payload].sort((a, b) => sortByProp(a, b, 'libelle'));
                state.typeExcursionsFetchStatus = 'success';
            } else {
                console.error("fetchTypeExcursion payload is not an array:", action.payload);
                state.typeExcursions = [];
                state.typeExcursionsFetchStatus = 'error';
            }
        }).addCase(fetchTypeExcursion.pending, (state, action) => {
            state.typeExcursionsFetchStatus = 'loading';

        }).addCase(fetchTypeExcursion.rejected, (state, action) => {

            state.typeExcursionsFetchStatus = 'error';

        });
    }


});
export const { addTypeExcursion } = typeExcursionSlice.actions;
export default typeExcursionSlice;